import { Suspense } from "react";
import { Outlet } from "react-router";
import { Loading } from "../Loading/Loading";
import { BreadcrumbsLogyca } from "../BreadcrumbsLogyca";
import { Box } from "@mui/material";
import { NavBarLogyca } from "../NavBarLogyca";
import { RouteComponentProps } from "./model";
import "./style.scss";

function SuspenseLogyca({ view }: RouteComponentProps) {
  return <Suspense fallback={<Loading />}>{view}</Suspense>;
}

export function RouteMain() {
  return (
    <SuspenseLogyca
      view={
        <Box className="MainViewContainer">
          <NavBarLogyca />

          <BreadcrumbsLogyca />

          <Box className="MainViewContent">
            <Outlet />
          </Box>
        </Box>
      }
    />
  );
}

export function RouteOutlet() {
  return <SuspenseLogyca view={<Outlet />} />;
}

export function RouteComponent({ view }: RouteComponentProps) {
  return <SuspenseLogyca view={view} />;
}

export function RouteComponentWithDialog({ view }: RouteComponentProps) {
  return (
    <SuspenseLogyca
      view={
        <>
          {view}

          <Outlet />
        </>
      }
    />
  );
}
